import React from "react";

const VoicebaseReactPlayerContext = React.createContext({});

export default VoicebaseReactPlayerContext;
